import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: "normal",
  color: COLORS.black,
};

export const H3 = ({ children, fontWeight, color, fontStyle, dangerouslySetInnerHTML, fontFamily }) => {
  return (
    <Typography variant="h3" dangerouslySetInnerHTML={dangerouslySetInnerHTML} sx={{ fontWeight, color, fontStyle, fontFamily }}>
      {children}
    </Typography>
  );
};

H3.propTypes = {
  fontWeight: PropTypes.string,
  color: PropTypes.string,
};

H3.defaultProps = defaultProps;

export default H3;
